"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var seirekiToDate_1 = require("./seirekiToDate");
var warekiToDate_1 = require("./warekiToDate");
function converToDate(date) {
    if (date instanceof Date || date.getDate) {
        return date;
    }
    else if (Array.isArray(date)) {
        return typeof date[0] === 'number' ? seirekiToDate_1.default.apply(void 0, date) : warekiToDate_1.default.apply(void 0, date);
    }
    else {
        throw new Error('日付指定エラー');
    }
}
exports.default = converToDate;
